// extracted by mini-css-extract-plugin
export default {"card":"Disclaimer_card__fbueN","listStyleMarkdown":"Disclaimer_listStyleMarkdown__JHJWo"};